import React, { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import ErrorBoundary from '@maxtropy/web-monitor/es/Boundary';

const dispatchMicroAppLoaded = (routeError = false) => {
  if (!window.__MICRO_APP_ENVIRONMENT__) return;

  window.__PAGE_LOAD_DISPATCHED__ = true;
  window.rawWindow.dispatchEvent(
    new CustomEvent('micro-app-loaded', {
      detail: {
        name: 'ms-cc',
        data: { loaded: true, routeError },
      },
    })
  );
};

const ErrorRouteContent = () => {
  useEffect(() => {
    dispatchMicroAppLoaded(true);
  }, []);

  return <ErrorBoundary />;
};

export default function RootRouteBoundary() {
  const error = useRouteError();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return <ErrorRouteContent />;
}

export function NotFoundRoute() {
  return <ErrorRouteContent />;
}
